import { CSSProperties } from "react";

interface IAudioPlayerProps {
  url: string;
  style: CSSProperties;
}
function AudioPlayer({ url, style }: IAudioPlayerProps) {
  return <audio src={url} style={style} controls></audio>;
}

export default AudioPlayer;
